import { EventsSegment } from 'app/helpers/EventsSegmentsCalculators';
import {
  buildUpgradeTrackingProperties,
  selectNewTierPlan,
  SelectableOffer,
} from 'app/hooks/useSubscriptionPlans/selectNewTierPlan';
import type { NewTierPlan } from 'app/hooks/useSubscriptionPlans/getNewTierPlans';
import useSubscriptionStatus from 'app/hooks/useSubscriptionStatus';

import { trackExplorePlansPlanSelected } from './trackPlanAndPaymentEvents';

export type UseHandleSelectNewTierPlanParams = {
  formik: { setFieldValue: (field: string, value: unknown) => void };
  selectPlan: () => void;
  user: unknown;
  subscriptionStatus: unknown;
  url: string;
  // catálogo já resolvido (hardcoded ou API) de quem chama; quando presente,
  // o checkout usa a oferta encontrada por planKey em vez de reconsultar o catálogo hardcoded.
  offers?: SelectableOffer[];
};

const findOfferByKey = (
  offers: SelectableOffer[] | undefined,
  planKey: NewTierPlan['key'],
): SelectableOffer | undefined => offers?.find(offer => offer.key === planKey);

// Shared select handler for ExplorePlansModal and ComparePlansModal CTAs.
export const useHandleSelectNewTierPlan = ({
  formik,
  selectPlan,
  user,
  subscriptionStatus,
  url,
  offers,
}: UseHandleSelectNewTierPlanParams) => {
  const { LimitReachModal } = EventsSegment();
  // cliente ativo em plano legado (sem plano atual resolvível no catálogo)
  // ainda conta como upgrade, não reativação: a fonte é isActive, nunca a ausência de is_current.
  const { isActive, currentTier } = useSubscriptionStatus();
  const mode = isActive ? 'upgrade' : 'reactivation';

  return (planKey: NewTierPlan['key']) => {
    LimitReachModal('Limit Reach Upgrade Button Clicked', { context: url });
    const offer = findOfferByKey(offers, planKey);
    const planSelected = selectNewTierPlan({
      planKey,
      offer,
      formik,
      selectPlan,
      user,
      subscriptionStatus,
      url,
      mode,
      currentTier,
    });

    if (planSelected) {
      // Grava aqui (não em selectNewTierPlan.ts): o formik local do
      // PlanExplorationModal (único chamador desta hook) é quem reusa isso no checkout; call
      // sites com formik real não passam por aqui.
      formik.setFieldValue(
        'upgrade_tracking_properties',
        buildUpgradeTrackingProperties({ mode, currentTier, planKey, offer }),
      );
      trackExplorePlansPlanSelected(planKey);
    }
  };
};
